import Alpine from 'alpinejs';
import api, { money, requireAuth } from './api.js';

function createInkoCreationPrintOrders() {
  return {
    loading: true,
    orders: [],

    async init() {
      if (!requireAuth()) return;
      try {
        this.orders = await api.listPrintOrders();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat order.', 'error');
      } finally {
        this.loading = false;
      }
    },

    money,
  };
}

Alpine.data('inkoCreationPrintOrders', createInkoCreationPrintOrders);
